<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="label-container" *ngIf="payload.properties.text?.value">
  <label class="flex jcc">
    <span>
      <span [innerHTML]="payload.properties.text?.value | tokenToDiv"></span>
      <span class="required" *ngIf="payload.properties.required.value">*</span>
    </span>
  </label>
</div>
<div class="label-container" *ngIf="payload.properties.content?.value">
  <label class="flex jcc subtitle">
    <span [innerHTML]="payload.properties.content?.value | tokenToDiv"></span>
  </label>
</div>
<div class="fb-signature" (click)="sign()">
  <div>
    <div class="signature-placeholder" *ngIf="!isSigned()">
      <span>Tap here to sign</span>
    </div>
    <div class="signature-line">
      <input type="text" tabindex="0" />
    </div>

    <div class="signature-wrapper">
      <div class="signature-container flex aic jcc" [style.background-image]="getBackground()">
        <!-- TODO: Drawing component-->
      </div>
    </div>
  </div>

  <div class="signee-info" *ngIf="canShowSigneeInfo()">
    <div class="signee-info__name-date">
      Electronically signed on {{ getSigneeDate() | dateFormat: 'MMM D [at] hh:mm a z' }}
    </div>
    <div class="signee-info__ip">IP address: {{ getSigneeIP() }}</div>
  </div>
</div>
<div
  *ngIf="payload.properties.hint?.value"
  class="hint"
  [innerHTML]="payload.properties.hint?.value | tokenToDiv"
></div>
<div *ngIf="payload.properties.required.value && isSubmitted && !isValid()" class="hint-required">
  This field is required
</div>

<ng-template #contentTemplate>
  <div class="fe-alert-backdrop"></div>
  <div class="fe-alert-container">
    <div class="container__wrapper">
      <h2 class="container__title">Alert</h2>
      <p class="container__body">
        You are not authorized to sign this section. Please select the appropriate signature type.
      </p>
      <div class="container__buttons">
        <button (click)="closeRestrictedAlert()">OK</button>
      </div>
    </div>
  </div>
</ng-template>
